export const subsListActions = {
    SET_SUBSLIST: 'SET_SUBSLIST'
};

const sublistreducer = (state, action) => {
    switch (action.type) {
        case subsListActions.SET_SUBSLIST:
            return {
                ...state,
                subList: action.subList,
            };
        default:
            return {
                state
            };
    }
};

export default sublistreducer;